import 'css-chunksrc/client/pages/zonePage/calendarPage/styles.scss';export default {
  "calendarPage": "_calendarPage_1f51m_1",
  "calendar": "_calendar_1f51m_1"
};